// LAS TAREAS RECIÉN LLEGADAS, ARRIBA (13-10, hoja de los probadores: M1 y M2).
//
// La pantalla Tareas parte lo pendiente en vencidas, para hoy y lo que viene, y eso lo
// decide el servidor por la fecha PARA la que se pide (`core/tareas.ordenar_para_panel`).
// Una tarea que nace hoy con fecha futura (la de "Preparar los macros y la rutina de un
// alta nueva" se pide para el viernes antes de que empiece, regla 3 del catálogo) caía en
// "Lo que viene", al final de la lista, y quien la recibía no la veía llegar.
//
// Aquí no se cambia ningún plazo: solo se sacan de "Lo que viene" las que se han creado HOY
// para enseñarlas las primeras, con su fecha. Mañana vuelven a su sitio. "Hoy" es el día de
// España que manda el servidor (`hoy_es`), y `created_at` es un instante en UTC: se pasa a
// día de España antes de comparar, que UTC no decide un día.
//
// Lógica pura: sin React y sin red.
import { aFecha, diaEnEspana } from './horaEspana';

/** ¿Se creó esta tarea hoy (día de España)? Sin fecha de creación, no. */
export const esDeHoy = (tarea, hoyEs) => {
    const creada = aFecha(tarea?.created_at);
    return !!creada && !!hoyEs && diaEnEspana(creada) === hoyEs;
};

/**
 * Parte "Lo que viene" en dos: las creadas hoy (la más reciente primero) y el resto, que
 * sigue en el orden en que llegó (por fecha de entrega).
 */
export const partirLoQueViene = (proximas, hoyEs) => {
    const nuevas = [];
    const resto = [];
    (proximas || []).forEach((t) => (esDeHoy(t, hoyEs) ? nuevas : resto).push(t));
    nuevas.sort((a, b) => String(b.created_at).localeCompare(String(a.created_at)));
    return { nuevas, resto };
};
